export enum MissionTabsEnum {
  MISSIONS = 'missions',
  HISTORY = 'missionsHistory',
}
